import React from 'react';
import PanelLayout from './PanelLayout';
import { paths } from '../routes/paths';
import { ADMIN_SECTIONS } from '../pages/admin/sections';

// /admin/* : the shared panel shell with the admin's sections. Admin role only (guard in AppRoutes).
export default function AdminLayout() {
  return <PanelLayout label="ADMIN" sections={ADMIN_SECTIONS} profilePath={paths.admin.profile} fallbackTitle="Admin" />;
}
